var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.667 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.775 4.694a5.361 5.361 0 00-3.772-3.8c-3.327-.9-16.67-.9-16.67-.9s-13.342 0-16.67.9a5.361 5.361 0 00-3.772 3.8C0 8.043 0 15.03 0 15.03s0 6.987.892 10.336A5.281 5.281 0 004.664 29.1c3.327.9 16.67.9 16.67.9s13.342 0 16.67-.9a5.281 5.281 0 003.772-3.736c.892-3.349.892-10.336.892-10.336s0-6.987-.892-10.336zM16.97 21.374V8.686l11.151 6.344-11.151 6.344z",
    fill: "currentColor"
  })));
}
export default SvgYoutube;